import React, { Component } from "react";
import { connect } from "react-redux";
import { isOpenBookaDemo } from "../../../action/index.js";

class Meeting extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isOpenMeeting } = this.props.const_var;

    // let calendalyUrl;

    // if (this.props.meetingfor == "walkerbuilding") {
    //   calendalyUrl =
    //     "https://calendly.com/d/3t7-2jw-t5r/pre-construction-meeting?hide_gdpr_banner=1";
    // } else if (
    //   this.props.const_var.crmSetting.main_domain_url == "eaglebuildings.com"
    // ) {
    //   calendalyUrl = "";
    // } else {
    //   calendalyUrl = "https://calendly.com/senseidigital";
    // }

    return (
      <>
        <div
          className={isOpenMeeting ? "custom-overlay active" : "custom-overlay"}
        ></div>
        <div
          className={isOpenMeeting ? "active meeting-modal" : "meeting-modal"}
        >
          <div
            className="close-icon rotate-icon"
            onClick={(e) => this.props.isOpenBookaDemo(false)}
          >
            <i className="icon close icon-close"></i>
          </div>

          <div
            className="meeting-content"
            style={{ marginBottom: 20, color: "black" }}
          >
            <div
              class="calendly-inline-widget"
              // data-url={calendalyUrl}
              style={{ width: "100%", height: "600px" }}
            ></div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.reducer,
});

const mapDispatchToProps = {
  isOpenBookaDemo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Meeting);
